import React from 'react';
import { Image } from 'react-bootstrap';

/**
 * Renderizza un'immagine profilo o un'icona predefinita se l'immagine non è disponibile
 * @param {string} src - URL dell'immagine
 * @param {string} alt - Testo alternativo
 * @param {number} size - Dimensione dell'immagine in pixel
 * @returns {JSX.Element} - Componente React
 */
export const renderProfileImage = (src, alt, size = 60) => {
  if (src) {
    return (
      <Image 
        src={src} 
        alt={alt} 
        roundedCircle 
        width={size} 
        height={size} 
        className="shadow-sm border" 
      />
    );
  } else {
    return (
      <div 
        className="d-flex justify-content-center align-items-center bg-light rounded-circle shadow-sm border"
        style={{ width: size, height: size }}
      >
        <i className="bi bi-person text-secondary" style={{ fontSize: `${size/24}rem` }}></i>
      </div>
    );
  }
};

/**
 * Renderizza un'immagine avatar o un'icona predefinita se l'immagine non è disponibile
 * @param {string} avatar - URL dell'immagine
 * @param {string} name - Nome utente
 * @param {number} size - Dimensione dell'avatar in pixel
 * @returns {JSX.Element} - Componente React
 */
export const renderAvatar = (avatar, name, size = 100) => {
  if (avatar) {
    return (
      <Image 
        src={avatar} 
        alt={name} 
        roundedCircle 
        width={size} 
        height={size} 
        className="shadow-sm border mb-2" 
      />
    );
  } else {
    return (
      <div 
        className="d-flex justify-content-center align-items-center bg-light rounded-circle shadow-sm border mb-2"
        style={{ width: size, height: size }}
      >
        <i className="bi bi-person text-secondary" style={{ fontSize: `${size/40}rem` }}></i>
      </div>
    );
  }
};

/**
 * Renderizza il logo di un negozio o un'icona predefinita se il logo non è disponibile
 * @param {string} logoUrl - URL del logo
 * @param {string} shopName - Nome del negozio
 * @param {number} size - Dimensione del logo in pixel
 * @returns {JSX.Element} - Componente React
 */
export const renderShopLogo = (logoUrl, shopName, size = 40) => {
  if (logoUrl) {
    return (
      <Image 
        src={logoUrl} 
        alt={shopName} 
        roundedCircle 
        width={size} 
        height={size} 
        className="border shadow-sm" 
      />
    );
  } else {
    return (
      <div 
        className="d-flex justify-content-center align-items-center bg-light rounded-circle border shadow-sm"
        style={{ width: size, height: size }}
      >
        <i className="bi bi-shop text-secondary" style={{ fontSize: `${size/30}rem` }}></i>
      </div>
    );
  }
};

/**
 * Renderizza l'immagine di un prodotto o un'icona predefinita se l'immagine non è disponibile
 * @param {string} image - URL dell'immagine
 * @param {string} productName - Nome del prodotto
 * @param {string} className - Classi CSS aggiuntive
 * @returns {JSX.Element} - Componente React
 */
export const renderProductImage = (image, productName, className = '') => {
  if (image) {
    return (
      <Image 
        src={image} 
        alt={productName} 
        className={`${className} w-100 h-100`}
        style={{ objectFit: 'cover' }} 
      />
    );
  } else {
    return (
      <div 
        className={`${className} d-flex justify-content-center align-items-center bg-light w-100 h-100`}
      >
        <i className="bi bi-box text-secondary" style={{ fontSize: '2.5rem' }}></i>
      </div>
    );
  }
}; 